import React from 'react'
import { Box, Avatar, Stack, useTheme } from '@mui/material'
import { Zoom } from 'react-awesome-reveal'
import { Code, Web, DeveloperMode } from '@mui/icons-material'

export const WelcomeAnimation: React.FC = () => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '900px',
                height: { xs: '300px', md: '500px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
            }}
        >
            {/* Background gradient shapes */}
            <Box
                sx={{
                    position: 'absolute',
                    width: { xs: '250px', md: '500px' },
                    height: { xs: '250px', md: '500px' },
                    background: `radial-gradient(circle at 30% 30%, ${theme.palette.primary.light}35 0%, transparent 50%),
                                radial-gradient(circle at 70% 70%, ${theme.palette.secondary.light}35 0%, transparent 50%),
                                radial-gradient(circle at 50% 50%, ${theme.palette.warning.light}30 0%, transparent 50%)`,
                    animation: 'rotate 20s linear infinite',
                    '@keyframes rotate': {
                        '0%': {
                            transform: 'translate(-50%, -50%) rotate(0deg)',
                        },
                        '100%': {
                            transform: 'translate(-50%, -50%) rotate(360deg)',
                        },
                    },
                    top: '50%',
                    left: '50%',
                }}
            />
            <Stack
                direction="row"
                spacing={4}
                sx={{
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <Zoom delay={100} triggerOnce>
                    <Avatar
                        sx={{
                            width: { xs: 80, md: 120 },
                            height: { xs: 80, md: 120 },
                            bgcolor: 'primary.main',
                            boxShadow: `0 8px 32px ${theme.palette.primary.main}40`,
                        }}
                    >
                        <Code sx={{ fontSize: { xs: 40, md: 60 } }} />
                    </Avatar>
                </Zoom>
                <Zoom delay={300} triggerOnce>
                    <Avatar
                        sx={{
                            width: { xs: 80, md: 120 },
                            height: { xs: 80, md: 120 },
                            bgcolor: 'secondary.main',
                            boxShadow: `0 8px 32px ${theme.palette.secondary.main}40`,
                        }}
                    >
                        <Web sx={{ fontSize: { xs: 40, md: 60 } }} />
                    </Avatar>
                </Zoom>
                <Zoom delay={500} triggerOnce>
                    <Avatar
                        sx={{
                            width: { xs: 80, md: 120 },
                            height: { xs: 80, md: 120 },
                            bgcolor: 'warning.main',
                            boxShadow: `0 8px 32px ${theme.palette.warning.main}40`,
                        }}
                    >
                        <DeveloperMode sx={{ fontSize: { xs: 40, md: 60 } }} />
                    </Avatar>
                </Zoom>
            </Stack>
        </Box>
    )
}
